import { useApolloClient } from '@apollo/client';
import Papa from 'papaparse';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { executeGraphQLMutation } from '../../common/executeGraphQLQuery';
import { getKeysDataIfExist } from '../../common/Helper';
import ImportFile from '../../common/ImportFIle';
import { ADD_STANDALONE_ORCR_LEAD_BULK } from '../../services/standalone-orcr.gql';
import Modal from '../elements/Modal';
import sampleFile from '../../data/Sample_Standalone_Bulk_Upload.csv';
const BulkCreate = ({ bulkCreateModal, toggleBulkCreateModal, getLeadList, getLeadsInput, paginationInput, setIsLoading }) => {
    const client = useApolloClient();
    const [imageName, setImageName] = useState("");
    const [dataToInsert, setDataToInsert] = useState([]);

    const user_information = useSelector((state) => state.user.user_information);
    const UserInfo = JSON.parse(user_information);

    const uploadFileHanlder = (event) => {
        const file = event.target.files[0];
        if (!file) return;

        // ✅ Check file extension and MIME type
        const isCSV = file.type === 'text/csv' || file.name.toLowerCase().endsWith('.csv');

        if (!isCSV) {
            toast.error('Please upload a valid CSV file.');
            return;
        }

        Papa.parse(file, {
            header: true,
            skipEmptyLines: true,
            complete: (results) => {
                const data = results?.data?.reduce((result, item, index) => {
                    if (!item?.["Customer Name"]) {
                        toast.error(`Customer Name is missing in row ${index + 2} will be skipped`);
                        return result;
                    }
                    if (!item?.["Plate No"]) {
                        toast.error(`Plate No is missing in row ${index + 2} will be skipped`);
                        return result;
                    }
                    if (!item?.["MV File Number"]) {
                        toast.error(`MV File Number is missing in row ${index + 2} and will be skipped`);
                        return result;
                    }
                    if (!/^[0-9]{15}$/.test(item["MV File Number"])) {
                        toast.error(`MV File Number in row ${index + 2} must be exactly 15 digits`);
                        return result;
                    }
                    if (!item?.["OR Document Link"]) {
                        toast.error(`OR Document is missing in row ${index + 2} will be skipped`);
                        return result;
                    }
                    if (!item?.["CR Document Link"]) {
                        toast.error(`CR Document is missing in row ${index + 2} will be skipped`);
                        return result;
                    }
                    result.push({
                        ...getKeysDataIfExist(item, [["Customer Name", "owner_name"], ["Plate No", "plate"], ["MV File Number", "mv_file_no"], ["OR Document Link", "or_doc"], ["CR Document Link", "cr_doc"], ["Registration number", "registration_number"], ["Engine number", "engine_number"], ["Chassis number", "chassis_number"], ["Fuel type", "fuel_type"], ["Color", "color"], ["Seating capacity", "seating_capacity"], ["Address", "address"], ["Transmission", "transmission"], ["Model", "model"], ["Make", "make"], ["Make year", "make_year"], ["Variant", "variant"]])
                    });
                    return result;
                }, []
                );
                if (data?.length) {
                    setDataToInsert(data);
                    setImageName(`${data?.length} records are ready to import`);
                }
            },
        });
    };

    const bulkCreateLeads = async (e) => {
        e.preventDefault();
        // for (const item of dataToInsert) {
        await createLeads(dataToInsert);
        // };
        toggleBulkCreateModal();
        getLeadList({ getLeadsInput, paginationInput });
    };

    const donwloadSampleCSV = async (e) => {
        const link = document.createElement("a");
        link.href = sampleFile;
        link.download = "sample.csv";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const createLeads = async (dataToInsert) => {
        if (!dataToInsert?.length) {
            toast.error(`No Records are present`);
            return;
        }
        const payload = dataToInsert?.map((addLead) => {
            let uploadData = { ...addLead, lead_docs: [] };
            uploadData.lead_docs?.push({ doc_id: 1, doc_path: addLead.cr_doc });
            uploadData.lead_docs?.push({ doc_id: 2, doc_path: addLead.or_doc });
            delete uploadData?.or_doc;
            delete uploadData?.cr_doc;
            const hasCR = uploadData.lead_docs.find((lead) => lead.doc_id === 1);
            const hasOR = uploadData.lead_docs.find((lead) => lead.doc_id === 2);
            const isValidMakeYear = !isNaN(uploadData.make_year);

            if (!hasCR) toast.error("CR Document is required");
            if (!hasOR) toast.error("OR Document is required");
            // if (!isValidMakeYear) toast.error("Make year should be a number");
            uploadData = { ...uploadData, agent_fee: addLead.agent_fee === "" ? null : addLead.agent_fee, make_year: parseInt(uploadData.make_year) };
            return uploadData;
        });
        const variable = {
            api_called_by: "web",
            user_id: UserInfo?.id || 0,
            role_id: UserInfo?.role_id?.[0] || 0,
            createLeadInput: payload,
        };
        setIsLoading(true);
        try {
            const resp = await executeGraphQLMutation(ADD_STANDALONE_ORCR_LEAD_BULK(), variable, client);
            if (resp?.data?.standalone_create_lead_orcr_bulk?.success) {
                toast.success(resp?.data?.standalone_create_lead_orcr_bulk?.success || "Success");
            }
            if (resp?.data?.standalone_create_lead_orcr_bulk?.failed) {
                toast.error(resp?.data?.standalone_create_lead_orcr_bulk?.failed);
            }
        } catch (error) {
            toast.error(`${error.toString().replace('ApolloError:', '') || "Error while creating leads!"}`);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <>
            {
                bulkCreateModal ? (
                    <div className="view-timeline-popup image-timeline-popup bulk-create-modal">
                        <Modal show={bulkCreateModal} handleClose={() => toggleBulkCreateModal()}>
                            <div className="modal-header">
                                <h2>Upload CSV File</h2>
                            </div>
                            <div className="modal-body m-md-t h-300 bulk-create-modal-body" style={{ color: "#000", marginLeft: 'auto', marginRight: 'auto' }}>
                                <fieldset className="form-filed">
                                    <div className="image-uploader-outer">
                                        <ImportFile name={imageName} onChooseFile={uploadFileHanlder} field_text={'Upload Proof by dropping file here'} />
                                    </div>
                                </fieldset>
                                <br></br>
                                <div className="btn-save-remarks d-flex">
                                    <button
                                        aria-label="save naxt"
                                        onClick={bulkCreateLeads}
                                        className="btn-primary"
                                        disabled={!imageName || !dataToInsert?.length}
                                    >
                                        Submit
                                    </button>
                                    <button
                                        aria-label="save naxt"
                                        onClick={donwloadSampleCSV}
                                        className="btn-primary"
                                    >
                                        Sample CSV
                                    </button>
                                </div>
                            </div>
                        </Modal>
                    </div>
                ) : ''
            }
        </>
    );
};

export default BulkCreate;
